var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-1"},[_c('area-chart',{attrs:{"data":_vm.data,"dataset":{borderWidth: 3},"colors":['#b00'],"ytitle":"Earnings"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d813ab0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statistics/TotalEarningsStatistic.vue
// module id = null
// module chunks = 